define("shared/utils/redirect", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = redirect;
  0; //eaimeta@70e063a35619d71f0,"@embroider/macros"eaimeta@70e063a35619d71f

  /**
   * Redirects to the provided url. Exists to allow stubbing redirects in tests
   * as you cannot easily stub `window.location.href` directly.
   * An error will be thrown is this util runs during tests.
   */
  function redirect(url) {
    if (false) {
      throw new Error('The redirect util should be stubbed in tests to avoid accidental redirects');
    } // This should be the only place where `window.location.href` is called
    // eslint-disable-next-line @latermedia/later-linting/no-location-href


    window.location.href = url;
  }
});